import React from 'react'
import injectSheet from 'react-jss'
import {
  BudgetCalculation,
  BudgetInput,
  BudgetSlider,
  TitleContainer,
} from '../../'

const Budget = (props) => {
  const {
    budget,
    budgetOverview,
    budgetSelection,
    classes,
    setBudget,
  } = props

  const leftBound = budget.handle.hasBlock ? budget.handle.leftBoundWithPlot : budget.handle.leftBound
  const budgetIsSet = (budgetSelection !== null)

  return (
    <TitleContainer title={budget.config.title}>
      <div className={`${classes.budgetTileContainer} ${budgetIsSet && 'set'}`}>
        <div className={`${classes.elementContainer}`}>
          <div>
            <div className={`${classes.sliderFadeContainer}`}>
              <p>{budget.handle.description}</p>
            </div>
            <BudgetInput
              currency={budget.config.currency}
              increment={budget.config.increment}
              min={leftBound}
              max={budget.config.maxBudget}
              setBudget={setBudget}
              value={!budgetOverview.total ? budget.handle.value : budgetOverview.total}
              placeholder="Budget"
            />
          </div>
        </div>
        <div
          className={`${classes.sliderGrowContainer}`}
          style={{ height: `${budgetIsSet ? (this.slider && this.slider.clientHeight) : 0}px` }}
        >
          <div
            ref={(node) => { this.slider = node }}
          >
            <BudgetSlider
              budget={budget}
              budgetOverview={budgetOverview}
              leftBound={leftBound}
              setBudget={setBudget}
            />
          </div>
        </div>
      </div>

      <BudgetCalculation
        min={leftBound}
        setBudget={setBudget}
        {...budget}
      />
    </TitleContainer>
  )
}

const styles = theme => ({
  budgetTileContainer: {
    margin: `0px ${theme.sizes.gutter / 2}px`,
    backgroundColor: theme.colors.main_2,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '&.set $sliderFadeContainer': {
      height: '60px',
      opacity: 1,
    },
    '&.set $sliderGrowContainer': {
      opacity: 1,
    },
    '&.calculation': {
      marginTop: `${theme.sizes.gutter}px`,
      position: 'relative',
      opacity: 0,
      transition: [
        {
          property: 'opacity',
          duration: theme.speed.medium,
        },
      ],
      '&.set': {
        opacity: 1,
      },
    },
  },
  elementContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    '& > div': {
      maxWidth: `${theme.sizes.smallContainer}px`,
    },
  },
  sliderFadeContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    textAlign: 'center',
    color: theme.colors.main_3,
    padding: `0 ${theme.sizes.gutter / 2}px`,
    height: 0,
    opacity: 0,
    transition: [
      {
        property: 'height',
        duration: theme.speed.medium,
        timingFunction: theme.motion.deceleration,
      },
      {
        property: 'opacity',
        duration: theme.speed.medium,
        delay: theme.speed.fast,
        timingFunction: theme.motion.deceleration,
      },
    ],
    '& > p': {
      margin: 0,
    },
  },
  sliderGrowContainer: {
    width: '100%',
    height: 0,
    opacity: 0,
    transition: [
      {
        property: 'height',
        duration: theme.speed.medium,
        timingFunction: theme.motion.deceleration,
      },
      {
        property: 'opacity',
        duration: theme.speed.medium,
        delay: theme.speed.fast,
        timingFunction: theme.motion.deceleration,
      },
    ],
  },
})


export default injectSheet(styles)(Budget)



// WEBPACK FOOTER //
// ./src/modules/budget/components/budget.jsx